import Login from '../pages/Login'
import Home from '../pages/Home'
import People from '../pages/People'
import Events from '../pages/Events'
import Users from '../pages/Users'

import SingleEventPage from '../pages/SingleEvent'
import SingleUserPage from '../pages/SingleUser'
import SinglePersonPage from '../pages/SinglePerson'

export default [
  {
    meta: {
      public: true
    },
    path: '/login',
    component: Login,
    name: 'login'
  },
  {
    meta: {
      public: false
    },
    path: '/',
    component: Home,
    name: 'Home'
  },
  {
    meta: {
      public: false
    },
    path: '/people',
    component: People,
    name: 'People'
  },
  {
    meta: {
      public: false
    },
    path: '/events',
    component: Events,
    name: 'Events'
  },
  {
    meta: {
      public: false
    },
    path: '/users',
    component: Users,
    name: 'Users'
  },
  {
    meta: {
      public: false
    },
    path: '/event/:id',
    component: SingleEventPage,
    name: 'Event'
  },
  {
    meta: {
      public: false
    },
    path: '/user/:id',
    component: SingleUserPage,
    name: 'User'
  },
  {
    meta: {
      public: false
    },
    path: '/person/:id',
    component: SinglePersonPage,
    name: 'Person'
  }
]
